import { render } from "./toolbar.vue?vue&type=template&id=4025b002"
import script from "./toolbar.vue?vue&type=script&lang=js"
export * from "./toolbar.vue?vue&type=script&lang=js"

import "./toolbar.vue?vue&type=style&index=0&id=4025b002&lang=css"
script.render = render

export default script